import React from 'react';
import Link from 'next/link';

export default function HomepageButton (props) {
  return (
    <div className='live_btn_home'>
      {props.homeurl && (<Link href={props.homeurl}>
        <a
          className='live_link_cont'
          title='홈페이지 바로가기'
          role='button'
          aria-label={`${props.title} 홈페이지 바로가기`}
        >
          <span className='live_btn_icon'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='31.003'
              height='25.997'
              viewBox='0 0 31.003 25.997'
            >
              <path
                d='M518.163,510.27h0L503.7,498.932a1.117,1.117,0,0,0-1.3,0l-14.469,11.334a1,1,0,0,0,1.234,1.575l2.164-1.7V522.45a2.262,2.262,0,0,0,2.253,2.271h6.3a1,1,0,0,0,1-1v-6.6h4.29v6.6a1,1,0,0,0,1,1h6.295a2.261,2.261,0,0,0,2.255-2.268V510.109l2.215,1.736a1,1,0,1,0,1.234-1.575Zm-5.447,12.2a.261.261,0,0,1-.258.263h-5.29v-6.6a1,1,0,0,0-1-1h-6.29a1,1,0,0,0-1,1v6.6h-5.289a.252.252,0,0,1-.184-.077.263.263,0,0,1-.076-.19V508.582l9.719-7.613,9.668,7.574Z'
                transform='translate(-487.544 -498.724)'
              ></path>
            </svg>
            <i className='hide'>공식홈페이지</i>
          </span>
        </a>
      </Link>)}
    </div>
  );
}
